<template>
  <div class="container-fluid">
    <h5 class="mb-1">
      {{item.client.full_name}}
    </h5>
    <p class="fs-5">
      {{$t('message.Product')}}: <b>{{item.product.name}}</b>, {{$t('message.Quantity')}}: <b>{{item.quantity}}</b>
    </p>

    <b-button class="float-end ms-3"
      variant="primary"
      @click="onStore"
              :disabled="db"
    >
      {{$t('modal.button.accept')}}
    </b-button>

    <b-button class="float-end "
      variant="warning"
      @click="onClose"
    >
      {{$t('modal.button.back')}}
    </b-button>
  </div>
</template>

<script>
  import {storeAcceptOrder} from '../../../api/endpoints/orders'

  export default {
    name: "AcceptModal",
    props: {
      item: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        db: false,
      }
    },
    methods: {
      onStore() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        storeAcceptOrder(this.item.id).then( () => {
          this.openNotification(this.item);
          this.onClose();
        })
      },
      openNotification(obj) {
        // eslint-disable-next-line no-unused-vars
        const noti = this.$vs.notification({
          border: "primary",
          position: "top-right",
          title: obj.client.full_name,
          text: "Product: " + obj.product.name
        })
      },
      onClose() {
        this.$emit('onClose')
      }
    }
    
  }
</script>